import CTABand from "@/components/site/CTABand";
import { useT2 } from "@/context/ContentContext";

export default function Methode() {
  const { t } = useT2();
  return (
    <div data-testid="page-methode">
      <section className="relative py-24 md:py-32 border-b border-ducs-gold/10">
        <div className="absolute inset-0 dijon-pattern opacity-30" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <div className="label-caps mb-5">{t("methode.hero.eyebrow")}</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ducs-cream leading-tight tracking-tight max-w-4xl">
            {t("methode.hero.title.line1")}<br />
            <span className="text-ducs-gold italic">{t("methode.hero.title.accent")}</span>
          </h1>
          <div className="gold-divider mt-6" />
          <p className="mt-6 text-ducs-mist text-base md:text-lg leading-relaxed max-w-2xl whitespace-pre-line">
            {t("methode.hero.intro")}
          </p>
        </div>
      </section>

      <section className="py-20 md:py-32">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <ol className="relative border-l border-ducs-gold/30 pl-10 md:pl-14 space-y-14">
            {[1, 2, 3, 4, 5].map((i) => (
              <li key={i} className="relative">
                <span className="absolute -left-[42px] md:-left-[58px] -top-1 w-10 h-10 md:w-12 md:h-12 rounded-full border border-ducs-gold/50 bg-ducs-night flex items-center justify-center font-serif text-ducs-gold text-lg">
                  {t(`methode.step${i}.number`)}
                </span>
                <h3 className="font-serif text-2xl md:text-3xl text-ducs-cream">{t(`methode.step${i}.title`)}</h3>
                <p className="mt-3 text-ducs-mist leading-relaxed max-w-2xl whitespace-pre-line">{t(`methode.step${i}.body`)}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <CTABand
        eyebrow={t("methode.cta.eyebrow")}
        title={t("methode.cta.title")}
        subtitle={t("methode.cta.subtitle")}
        primaryLabel={t("methode.cta.button1")}
        secondaryLabel={t("methode.cta.button2")}
        secondaryTo="/contact"
      />
    </div>
  );
}
